// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10TDI","footer":"styles_footer__CwAIy","passCodeTooltip":"styles_passCodeTooltip__1P-83"};